module.exports = __webpack_public_path__ + "static/media/Amount.6a7dca3b.svg";